import { ROUTE } from 'constants/routes'

export const getTacPageUrl = (slugOrUrl: string) => {
  try {
    const url = new URL(slugOrUrl)
    return url.href
  } catch {
    return ROUTE.BLOG_DETAIL({ slug: slugOrUrl })
  }
}
